/**
 * @author Ryan Gladstone, Brendan Magee
 */

function TasksOverviewController(
  $scope,
  $log,
  $window,
  Task,
  taskModalService,
  LoggedInUser,
  groupsService,
  featureFlag
) {
  featureFlag.isEnabled('tasksv2').then((enabled) => {
    if (enabled) {
      $window.location.href = '/websked/1/tasks';
    }
  });

  const querySize = 5;
  const user = LoggedInUser;

  function creationSuccess(newTask) {
    if (newTask) {
      if (
        user.username === newTask.latestEvent.assignedUser &&
        $scope.myTasks.length < querySize
      ) {
        $scope.myTasks.unshift(newTask);
      } else if ($scope.allTasks.length < querySize) {
        $scope.allTasks.unshift(newTask);
      } else {
        $log.log('new task created: ', newTask);
      }
    }
  }

  groupsService.getGroups().then(
    (response) => {
      $scope.groups = response;
    },
    (response) => {
      // handle rejected promise here
      $log.error('TasksOverviewController getGroups()', response);
    }
  );

  const myTasksParams = {
    includeStories: true,
    size: querySize,
    assignedUsers: user.username,
    sortBy: 'createdDate',
    asc: false,
    status: [1, 2, 3]
  };

  Task.query(myTasksParams).then(
    (data) => {
      $scope.myTasks = data.results;
    },
    (response) => {
      $log.error('TasksOverviewController getTasks(mine)', response);
    }
  );

  const allTasksParams = {
    includeStories: true,
    size: querySize,
    sortBy: 'createdDate',
    asc: false,
    status: [1, 4]
  };

  Task.query(allTasksParams).then(
    (data) => {
      $scope.allTasks = data.results;
    },
    (response) => {
      $log.error('TasksOverviewController getTasks(mine)', response);
    }
  );

  $scope.createTask = () => {
    taskModalService.saveTask(creationSuccess);
  };
}

const TasksOverviewCtrlArray = [
  '$scope',
  '$log',
  '$window',
  'Task',
  'taskModalService',
  'LoggedInUser',
  'groupsService',
  'featureFlag',
  TasksOverviewController
];

export default function (ngModule) {
  ngModule.controller('TasksOverviewController', TasksOverviewCtrlArray);
}
